import React, {
  createContext,
  use,
  useContext,
  useEffect,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const AllDivisionContext = createContext();

export const ApiProvider = ({ children }) => {
  const [userId, setUserId] = useState(
    () => localStorage.getItem("user_id") || ""
  );
  const [merchantInfo, setMerchantInfo] = useState(() => {
    try {
      const stored = localStorage.getItem("merchantInfo");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });
  const [phoneNo, setPhoneNo] = useState(
    () => localStorage.getItem("phoneNo") || ""
  );
  const [isLoading, setIsLoading] = useState(false);

  const [userKycStatus, setUserKycStatus] = useState();
  const [moneyLoadStatus, setMoneyLoadStatus] = useState();

  const [intentLink, setIntentLink] = useState(
    () => localStorage.getItem("intentLink") || ""
  );

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log("✅ Decoded Token:", decoded);

        // Save in localStorage + state
        localStorage.setItem("merchantInfo", JSON.stringify(decoded));
        setMerchantInfo(decoded);

        // Redirect cleanly without token in URL
        navigate("/sign-up", {
          replace: true,
          state: { merchantInfo: decoded },
        });
      } catch (err) {
        console.error("❌ Invalid token:", err);
      }
    }
  }, [location.search, navigate]);

  // console.log("merchantInfo", intentLink);

  return (
    <AllDivisionContext.Provider
      value={{
        userId,
        setUserId,
        phoneNo,
        setPhoneNo,
        merchantInfo,
        setMerchantInfo,
        userKycStatus,
        setUserKycStatus,
        moneyLoadStatus,
        setMoneyLoadStatus,
        intentLink,
        setIntentLink,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </AllDivisionContext.Provider>
  );
};

export const useAllProduct = () => {
  const context = useContext(AllDivisionContext);
  if (!context) {
    throw new Error("useAllProduct must be used within an ApiProvider");
  }
  return context;
};

export default AllDivisionContext;
